<section>
  <div class='modal-top'>
    <h1>{{ 'pages.user-parking.addButton' | translate}}?</h1> <button (click)='closeClick()'>X</button>
  </div>

  <div class="modal-middle">
    <p>
      {{ 'pages.user-parking.addCreditMessage_1'| translate}}<span>{{this.money}} CAD</span>
      {{ 'pages.user-parking.addCreditMessage_2'| translate}}<span>{{this.user}} ?</span></p>
  </div>

  <div class='modal-bottom'>
    <button class='bciti-button bciti-button--invisible' (click)='closeClick()'>{{'pages.user-parking.cancel' | translate}}</button>
    <button class='bciti-button bciti-button--blue' (click)='okAddIt()'>{{'pages.user-parking.confirm' | translate}}</button>
  </div>
</section>